<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('mobileCode.areaCode')" prop="areaCode">
                <a-input v-model="queryParam.areaCode" :placeholder="$t('mobileCode.inputAreaCode')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('mobileCode.country')" prop="country">
                <a-input v-model="queryParam.country" :placeholder="$t('mobileCode.inputCountry')" allow-clear/>
              </a-form-item>
            </a-col>
<!--            <template v-if="advanced">-->
<!--              <a-col :md="5" :sm="24">-->
<!--                <a-form-item label="是否启用 0-启用 1-禁用" prop="isOpen">-->
<!--                  <a-input v-model="queryParam.isOpen" placeholder="请输入是否启用 0-启用 1-禁用" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--            </template>-->
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('common.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('common.reset') }}</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <!-- v-hasPermi="['mobileCode:mobileCode:add']" -->
        <a-button type="primary" @click="$refs.createForm.handleAdd()">
          <a-icon type="plus" />{{ $t('common.add') }}
        </a-button>
        <!-- v-hasPermi="['mobileCode:mobileCode:edit']" -->
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)">
          <a-icon type="edit" />{{ $t('common.edit') }}
        </a-button>
        <!-- v-hasPermi="['mobileCode:mobileCode:remove']" -->
        <a-button type="danger" :disabled="multiple" @click="handleDelete">
          <a-icon type="delete" />{{ $t('common.delete') }}
        </a-button>
<!--        <a-button type="primary" @click="handleExport" v-hasPermi="['mobileCode:mobileCode:export']">-->
<!--          <a-icon type="download" />导出-->
<!--        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>


        <span slot="isOpen" slot-scope="text, record">
          <a-switch :checkedChildren="$t('common.yes')" :unCheckedChildren="$t('common.no')" v-model="record.isOpen == 0" @change="changeIsOpen($event,record)"/>
        </span>
        <span slot="isCommonly" slot-scope="text, record">
          <a-switch :checkedChildren="$t('common.yes')" :unCheckedChildren="$t('common.no')" v-model="record.isCommonly == 1" @change="changeIsCommonly($event,record)"/>
        </span>


        <span slot="operation" slot-scope="text, record">
          <!-- v-hasPermi="['mobileCode:mobileCode:edit']" -->
          <a-divider type="vertical" />
          <!-- v-hasPermi="['mobileCode:mobileCode:edit']" -->
          <a @click="$refs.createForm.handleUpdate(record, undefined)">
            <a-icon type="edit" />{{ $t('common.edit') }}
          </a>
          <!-- v-hasPermi="['mobileCode:mobileCode:remove']" -->
          <a-divider type="vertical" />
          <!-- v-hasPermi="['mobileCode:mobileCode:remove']" -->
          <a @click="handleDelete(record)">
            <a-icon type="delete" />{{ $t('common.delete') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => $t('table.total', { total })"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageMobileCode,listMobileCode, delMobileCode,changeIsOpen } from '@/api/mobileCode/mobileCode'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'MobileCode',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        areaCode: null,
        country: null,
        isOpen: null,
        pageNum: 1,
        pageSize: 10
      },
    }
  },
  filters: {
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('mobileCode.areaCode'),
          dataIndex: 'areaCode',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('mobileCode.country'),
          dataIndex: 'countryIn',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('mobileCode.countryEn'),
          dataIndex: 'countryEn',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('mobileCode.countryCn'),
          dataIndex: 'countryCn',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('mobileCode.countryArabic'),
          dataIndex: 'country',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('mobileCode.status'),
          dataIndex: 'isOpen',
          scopedSlots: { customRender: 'isOpen' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('mobileCode.isCommonly'),
          dataIndex: 'isCommonly',
          scopedSlots: { customRender: 'isCommonly' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('common.operation'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.getList()
  },
  watch: {
  },
  methods: {
    /** 查询手机区号列表 */
    getList () {
      this.loading = true
     pageMobileCode(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        areaCode: undefined,
        country: undefined,
        isOpen: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },


    changeIsOpen (e,record) {
      record.isOpen = e ? 0 : 1
      changeIsOpen(record).then(response => {
        this.$message.success(
          this.$t('mobileCode.operationSuccess')
        )
        return  record.isOpen = e ? 0 : 1
      })
    },
    changeIsCommonly(e,record) {
      record.isCommonly = e ? 1 : 0
      changeIsOpen(record).then(response => {
        this.$message.success(
          this.$t('mobileCode.operationSuccess')
        )
        return  record.isCommonly = e ? 1 : 0
      })
    },
    // onShowSizeChange 方法已在 tableMixin 中统一处理，无需重复定义
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('mobileCode.confirmDelete'),
        content: this.$t('mobileCode.confirmDeleteContent') + ids,
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delMobileCode(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('common.deleteSuccess'),
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('mobileCode.confirmExport'),
        content: this.$t('mobileCode.confirmExportContent'),
        onOk () {
          that.download('mobileCode/mobileCode/export', {
            ...that.queryParam
          }, `${that.$t('mobileCode.exportFileName')}_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
